import styled from 'styled-components';
import { motion } from 'framer-motion';

const Layout = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: calc(100vh - 230px);
  flex-direction: column;
  background: ${(props) => props.theme.appLayout.layoutBackground};
  margin-top: 100px;
  width: 100%;

  @media (max-width: 800px) {
    margin-top: 80px;
  }
`;

export const LayoutContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 100px);
`;

const Main = styled.div`
  width: calc(100% - 80px);
  padding: 0 40px;
  margin: 40px 40px;
  max-width: 100%;
  z-index: 1;
  border-radius: 16px;

  /* background: ${({ theme }) => theme.colors.neutral0}; */

  @media (max-width: 800px) {
    width: calc(100% - 20px);
    margin: 10px 10px;
  }
`;

const MainWrapper = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    padding: 0 32px;
  }
`;

const MainNav = styled.div`
  max-width: 1687px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
`;

const TopNavigation = styled(motion.div)`
  width: calc(100% - 80px);
  background: ${(props) => props.theme.appLayout.navBackground};
  color: ${(props) => props.theme.appLayout.navFontColor};
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px;
  position: fixed;
  top: 20px;
  left: 40px;
  right: 40px;
  z-index: 100;
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  border-radius: 100px;

  @media (max-width: 800px) {
    padding: 0 20px;
    z-index: 110;

    width: calc(100% - 20px);
    top: 10px;
    left: 10px;
    right: 10px;
  }

  a {
    color: ${(props) => props.theme.appLayout.navFontColor} !important;
  }
`;

const TopNavigationMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* max-width: 1280px; */
`;

const Navigation = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FooterStyled = styled.div`
  width: calc(100% - 80px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-bottom: 20px; */
  /* margin-top: 20px; */
  margin: 40px 40px;
  color: ${(props) => props.theme.colors.neutral900} !important;
  background: ${({ theme }) => theme.colors.neutral0};
  border-radius: 200px;
  padding: 10px 30px;

  > * {
    color: ${(props) => props.theme.colors.neutral900} !important;
  }

  a {
    color: ${(props) => props.theme.colors.neutral900} !important;
  }
  img {
    height: 24px;
  }
`;

export const FooterMobileStyled = styled.div`
  background: ${({ theme }) => theme.colors.neutral0};
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 20px;
  gap: 3px;
  border-radius: 200px;
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 10px 20px;

  img {
    width: 100px;
  }
`;

const SideButtons = styled(motion.div)`
  padding-top: 70px;
  width: 72px;
  background: ${(props) => props.theme.appLayout.sideNavBackground};
  position: fixed;
  top: 70px;
  left: 0;
  overflow: hidden;
  min-height: calc(100vh - 70px);
  box-shadow: ${(props) => props.theme.shadows.shadowXS};
  z-index: 98;

  img {
    margin: 20px;
    width: 32px;
  }

  p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: none;
    opacity: 0;
  }

  button {
    opacity: 0;
  }

  :hover {
    width: 210px;
    p {
      opacity: 1;
      display: flex;
      flex: none;
    }
    button {
      opacity: 1;
    }
  }
  transition: all 0.2s ease;
  @media (max-width: 800px) {
    display: none;
  }
`;

const SideButtonsContent = styled.div`
  width: 100%;

  img {
    margin: 0px;
  }
`;

export const Menu = styled.div<{
  isOpen: boolean;
  center?: boolean;
  left?: boolean;
  width?: string;
}>`
  background: ${(props) => props.theme.appLayout.navBackground};
  border-radius: 16px;
  padding: 30px;
  position: absolute;
  top: 60px;
  ${({ left }) => (left ? 'left: 0;' : 'right: 0;')};
  width: ${({ width }) => width || '350px'};
  font-size: 16px;
  line-height: 20px;
  border: 1px solid ${(props) => props.theme.colors.neutral400};
  max-height: calc(100vh - 150px);
  overflow-y: auto;

  span {
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }

  /* ${(props) => (props.isOpen ? 'display: block;' : 'display: none;')}; */
  ${(props) => (props.isOpen ? 'visibility: visible;' : 'visibility: hidden;')}
  ${(props) => (props.isOpen ? 'opacity: 1;' : 'opacity: 0;')};
  transform: ${(props) =>
    props.isOpen ? ' translateY(0)' : 'translateY(-20px)'};

  transition: all 0.2s ease;

  z-index: 100005;

  ${({ center }) =>
    center &&
    `
    left: 50%;
    right: auto;
    transform: translate(-50%, 0%);
  `}

  @media (max-width: 800px) {
    width: 300px;
    padding: 20px;
    top: 60px;
  }
`;

export const MenuInviteLabels = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* color: #ffffff; */
  margin-bottom: 12px;
`;

export const MenuInvitePlaceholder = styled.div`
  /* background: ${(props) => props.theme.colors.neutral100}; */
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  border-radius: 15px;
  min-height: 48px;
  width: 100%;
  padding: 18px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 12px;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral700};
  word-break: break-all;
`;

export const Collapsable = styled.div<{ expanded: boolean }>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  max-height: ${(props) => (props.expanded ? '388px' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  transition: all 0.3s ease;
`;

export const LanguageSelect = styled.select`
  background: none;
  color: ${(props) => props.theme.colors.neutral900} !important;
  border: none;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  color: ${(props) => props.theme.dashboard.fontColor};
  margin-bottom: 24px;

  display: flex;
  align-items: center;
`;

export {
  Layout,
  Main,
  MainWrapper,
  TopNavigation,
  MainNav,
  Navigation,
  FooterStyled,
  TopNavigationMain,
  SideButtons,
  SideButtonsContent
};
